// extracted by mini-css-extract-plugin
export default {"button":"_2nzAELVU0TYBn5c_qSdS7C"};